/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { FranchiseTierTranslationRequestDto } from './franchiseTierTranslationRequestDto';
import { SpecialPricePartialRateRequestDto } from './specialPricePartialRateRequestDto';

export interface FranchiseTierRequestDto {
  id: string;
  translations: Array<FranchiseTierTranslationRequestDto>;
  isActive: boolean;
  priceType: FranchiseTierRequestDto.PriceTypeEnum;
  specialRate: number;
  relativePriceType: FranchiseTierRequestDto.RelativePriceTypeEnum;
  specialPricePartialRates: Array<SpecialPricePartialRateRequestDto>;
}
// tslint:disable-next-line:no-namespace
export namespace FranchiseTierRequestDto {
  export type PriceTypeEnum = 'normal_price' | 'special_price' | 'special_price_partial';
  export const PriceTypeEnum = {
      NormalPrice: 'normal_price' as PriceTypeEnum,
      SpecialPrice: 'special_price' as PriceTypeEnum,
      SpecialPricePartial: 'special_price_partial' as PriceTypeEnum,
  };
  export type RelativePriceTypeEnum = 'relative_amount' | 'relative_percentage';
  export const RelativePriceTypeEnum = {
      Amount: 'relative_amount' as RelativePriceTypeEnum,
      Percentage: 'relative_percentage' as RelativePriceTypeEnum,
  };
}
